module.exports = __webpack_public_path__ + "img/brackets-minus.dda17a03.svg";